import { z } from "zod";
export const UIToggleSchema = z.object({
    type: z.string(),
    label: z.string(),
    selected: z.boolean(),
});
export const UIToggleListSchema = z.array(UIToggleSchema);
//# sourceMappingURL=ui-toggles.js.map